import { render } from "./ExamManagement.vue?vue&type=template&id=f021f3ac&scoped=true"
import script from "./ExamManagement.vue?vue&type=script&lang=js"
export * from "./ExamManagement.vue?vue&type=script&lang=js"

import "./ExamManagement.vue?vue&type=style&index=0&id=f021f3ac&lang=scss&scoped=true"
import "./ExamManagement.vue?vue&type=style&index=1&id=f021f3ac&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f021f3ac"]])

export default __exports__